import { gql } from "@apollo/client";

export const FIND_STRATEGY_CONSIDERATION_BY_STRATEGY = gql`
  query FindStrategyConsiderationByStrategy($uuid: ID!) {
    findStrategyConsiderationByStrategy(uuid: $uuid) {
      summary
      uuid
    }
  }
`;

export const UPDATE_STRATEGY_CONSIDERATION = gql`
  mutation UpdateStrategyConsideration(
    $data: UpdateStrategyConsiderationInput!
  ) {
    updateStrategyConsideration(data: $data) {
      summary
      uuid
    }
  }
`;

export const FIND_ALL_CONSIDERATION_BY_STRATEGY_CONSIDERATION = gql`
  query FindAllConsiderationByStrategyConsideration($uuid: ID!) {
    findAllConsiderationByStrategyConsideration(uuid: $uuid) {
      description
      email
      firstName
      impactOnMitigationTimeLine
      lastName
      otherConsideration
      uuid
    }
  }
`;

export const CREATE_CONSIDERATION = gql`
  mutation Consideration($data: CreateConsiderationInput!) {
    createConsideration(data: $data) {
      description
      email
      firstName
      impactOnMitigationTimeLine
      lastName
      otherConsideration
      uuid
    }
  }
`;

export const UPDATE_CONSIDERATION = gql`
  mutation Consideration($data: UpdateConsiderationInput!) {
    updateConsideration(data: $data) {
      description
      email
      firstName
      impactOnMitigationTimeLine
      lastName
      otherConsideration
      uuid
    }
  }
`;

export const DELETE_CONSIDERATION = gql`
  mutation DeleteConsideration($uuid: ID!) {
    deleteConsideration(uuid: $uuid) {
      description
      email
      firstName
      impactOnMitigationTimeLine
      lastName
      otherConsideration
      uuid
    }
  }
`;
